<template>
  <sfs-base-list-filter
    title="Filter Invoice Items"
    :table-name="tableName"
    :applied-filters="appliedFilters"
    :displayed-columns="displayedColumns"
    :available-columns="availableColumns"
    @filters-applied="onFiltersApplied"
    @filters-reset="onDefaultPresetApplied"
    @filter-cleared="onFilterCleared"
    :column-picker="false"
    :advanced-filter="false"
  >
    <template #quick-filters>
      <b-form-group
        label="Search fields for Data"
        label-for="quick-filter-text"
        label-sr-only
      >
        <b-input-group>
          <b-form-input
            id="quick-filter-text"
            v-model="filters.text"
            type="text"
            placeholder="Filter by Work Order Number, Description or Store #"
            @keydown.enter.native="applyFilters"
          />
          <template #append>
            <b-button
              id="quick-filter-apply-button"
              @click="applyFilters"
              variant="primary"
            >
              <i class="fa fa-search" />
            </b-button>
          </template>
        </b-input-group>
      </b-form-group>
    </template>

    <template #right-tray>
      <b-dropdown
        v-if="$can('create_item', invoice)"
        class="ml-2"
        variant="primary"
        v-b-tooltip.hover
        title="Create a new Invoice Item"
      >
        <template #button-content>
          <i class="fa fa-plus mr-1" />
          New Item
        </template>
        <b-dropdown-item v-b-modal.invoice-item-add-modal>
          Add Item
        </b-dropdown-item>
        <b-dropdown-item v-b-modal.invoice-item-add-work-order-charge-modal>
          Add Work Order Charge
        </b-dropdown-item>
        <b-dropdown-item v-b-modal.invoice-item-add-recurring-charge-modal>
          Add Recurring Charge
        </b-dropdown-item>
      </b-dropdown>
      <sfs-download-button
        v-b-tooltip.hover
        class="ml-2"
        filename="Invoice Items.csv"
        :file-provider="getItemsSpreadsheet"
        title="Download spreadsheet"
      />
      <new-modal
        v-if="$can('create_item', invoice)"
        :invoice_id="invoice.id"
        :client_id="invoice.client_id"
        @on-save="refreshTable"
      />
      <add-work-order-charge-modal
        v-if="$can('create_item', invoice)"
        :invoice_id="invoice.id"
        :client_id="invoice.client_id"
        @on-save="refreshTable"
      />
      <add-recurring-charge-modal
        v-if="$can('create_item', invoice)"
        :invoice_id="invoice.id"
        :client_id="invoice.client_id"
        :start_date="periodStart"
        :end_date="periodEnd"
        @on-save="refreshTable"
      />
    </template>
  </sfs-base-list-filter>
</template>
<script>
import { DateTime } from 'luxon';
import NewModal from '@/components/admin/invoiceItems/NewModal.vue';
import AddWorkOrderChargeModal from '@/components/admin/invoiceItems/AddWorkOrderChargeModal.vue';
import AddRecurringChargeModal from '@/components/admin/invoiceItems/AddRecurringChargeModal.vue';
import { INVOICE_ITEM_TABLE_COLUMN_OPTIONS, INVOICE_ITEM_TABLE_DEFAULT_COLUMNS, INVOICE_ITEM_TABLE_NAME, } from '@/constants/invoiceItems';
import listFilterMixin from '@/mixins/listFilterMixin';

export default {
  name: 'InvoiceItemsListFilter',
  mixins: [listFilterMixin],
  components: {
    NewModal,
    AddWorkOrderChargeModal,
    AddRecurringChargeModal,
  },
  props: {
    invoice: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      availableColumns: INVOICE_ITEM_TABLE_COLUMN_OPTIONS,
      tableName: INVOICE_ITEM_TABLE_NAME,
    };
  },
  mounted() {
    this.applyFilters();
  },
  methods: {
    onDefaultPresetApplied() {
      this.filters = {};
      this.displayedColumns = INVOICE_ITEM_TABLE_DEFAULT_COLUMNS;
      this.applyFilters();
    },
    getItemsSpreadsheet() {
      return this.$invoicesAPI.getItemsSpreadsheet(this.invoice.id);
    },
    refreshTable() {
      this.$emit('data-changed');
    },
  },
  computed: {
    periodStart() {
      return this.invoice.date;
    },
    periodEnd() {
      return DateTime.fromISO(this.invoice.date).plus({ months: 1 }).minus({ days: 1 }).toISODate();
    },
  }
};
</script>
